import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { Button, Modal, Form, OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap'
import Select from 'react-select'

function StartModal(props) {

	const navigate = useNavigate();
	const [formData, setFormData] = useState({limit:100, offset:0});
	const [validated, setValidated] = useState(false);
	const [mode, setMode] = useState(2);
	const [excludeCaptcha, setExcludeCaptcha] = useState(0);
	const [excludeFailed, setExcludeFailed] = useState(0);
	const [excludeFilled, setExcludeFilled] = useState(0);
	const [timeRestriction, setTimeRestriction] = useState(false);
	const [lists, setLists] = useState();
	const [isloading, setLoading] = useState(false);

	const isTimezoneInvalid = timeRestriction && validated && (!formData.timezone);
	// List is invalid when we've validated and neither a list nor contact numbers are provided
	const isListInvalid = validated && (!formData.selectedlist && !(formData.contactnumbers && formData.contactnumbers.trim() !== ''))

	useEffect(() => {
		axios({
			url: `/getlists/${props.uid}`,
			method: "POST"
		})
			.then((response) => setLists(response.data))
			.catch((err) => console.error("Error to fetch lists: ", err));
	}, []);

	// Days of the week: 1 = Sunday, 2 = Monday, ..., 7 = Saturday
	const days =[    
		{ value: 1, label: 'Sunday' },
		{ value: 2, label: 'Monday' },
		{ value: 3, label: 'Tuesday' },
		{ value: 4, label: 'Wednesday' },
		{ value: 5, label: 'Thursday' },
		{ value: 6, label: 'Friday' },
		{ value: 7, label: 'Saturday' }
];

	const timezones = [
		{ value: "Asia/Kolkata", label: "Asia/Kolkata" },
		{ value: "America/New_York", label: "America/New_York" },
		{ value: "America/Chicago", label: "America/Chicago" },
		{ value: "America/Denver", label: "America/Denver" },
		{ value: "America/Los_Angeles", label: "America/Los_Angeles" },
		{ value: "America/Phoenix", label: "America/Phoenix" },
		{ value: "America/Anchorage", label: "America/Anchorage" },
		{ value: "Pacific/Honolulu", label: "Pacific/Honolulu" }
	];



	const resetMode = () => {
		setMode(2)// resetting mode back to the default manual review mode
	}


	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	}

	const handleSelectorChange = (selectedOption, actionMeta) => {
		const { name } = actionMeta;
		setValidated(false)
		setFormData({ ...formData, [name]: selectedOption });
	}

	const handleModeCheckbox = (event) => {
		if (event.target.checked) setMode(1)
		else setMode(2)
	}

	const handleCaptchaCheckbox = (event) => {
		if (event.target.checked) setExcludeCaptcha(1)
		else setExcludeCaptcha(0)
	}

	const handleFailedCheckbox = (event) => {
		if (event.target.checked) setExcludeFailed(1)
		else setExcludeFailed(0)
	}

	// const handleFilledCheckbox = (event) => {
	// 	if (event.target.checked) setExcludeFilled(1)
	// 	else setExcludeFilled(0)
	// }
	
	const handleTimeRestrictionCheckbox = (event) => {
		if (event.target.checked) {
			setTimeRestriction(true);
		}
		else {
			setTimeRestriction(false);
		}
	}

	const startcampaign = (e) => {
        setLoading(true);
		const isCustomInvalid = (timeRestriction && (!formData.timezone)) || (!formData.selectedlist && !(formData.contactnumbers && formData.contactnumbers.trim() !== ''));

		setValidated(true);
		const form = e.currentTarget;


		if (form.checkValidity() === false || isCustomInvalid) {
			e.preventDefault();
			e.stopPropagation();
		}

		if (form.checkValidity() === true && !isCustomInvalid) {

			axios.post(`/voicecampaign`, {
				agentid: props.selectedAgent.id,
				userid: props.uid,
				// modeid: mode,
				// ignorecaptcha: excludeCaptcha,
				// ignorefailed: excludeFailed,
				// ignorefilled: excludeFilled,
				...formData
			})
				.then(res => {
                    alert(`Campaign Started! \n ${res.data.message}`);
					props.setShowstartmodal(false)
					setFormData({})
					navigate("/campaigns/voice-campaigns");
					// props.setCampaignRefresh(prevdata => !prevdata)
				})
				.catch(err => {
					console.log(err)
				})
			e.preventDefault();
			e.stopPropagation();
		}
	}

	return (
		<>
			<Modal
				show={props.showstartmodal}
				onHide={() => {
					props.setShowstartmodal(false);
					resetMode();
				}}
				centered
				size="lg">
				<Modal.Header closeButton={true} onClick={() => { setValidated(false); setFormData({}); setTimeRestriction(false); }}>
					<div className="fs-6">Start Voice Campaign</div>
				</Modal.Header>
				<Modal.Body className="m-1 p-3">
					<Form noValidate validated={validated} onSubmit={startcampaign}>
						<Form.Group className="mb-3">
							<Form.Label>Lists</Form.Label>
							<div style={{ 'border': isTimezoneInvalid ? '1px solid #801030' : undefined, 'border-radius': isTimezoneInvalid ? '4px' : undefined }}>
								<Select
									isMulti={false}
									name="selectedlist"
									options={lists}
									value={formData.selectedlist}
									onChange={handleSelectorChange}
									isClearable={false}
									backspaceRemovesValue={true}
									closeMenuOnSelect={true}
									isDisabled={false}
								/>
							</div>
							{isListInvalid &&
								(<div className='invalid-feedback d-block'>
									A list must be selected or contact numbers must be provided.
								</div>)
							}
						</Form.Group>

						{/* OR label and contact numbers input */}
						<div className="text-center my-2"><strong>OR</strong></div>
						<Form.Group className="mb-3">
							<Form.Label>Contact Numbers (comma separated)</Form.Label>
							<Form.Control
								as="textarea"
								rows={2}
								placeholder="+911234567890,+919876543210"
								value={formData.contactnumbers || ''}
								name="contactnumbers"
								onChange={handleChange}
								isInvalid={!formData.contactnumbers && validated && (!formData.selectedlist)}
							/>
						</Form.Group>

						<Row className="mb-3">
							<Col xs={12} md={6} >
								<Form.Group >
									<Form.Label>Entity{<span style={{ color: 'red' }}>*</span>}</Form.Label>
									<Form.Control
										type="text"
										placeholder="Entity"
										value={formData.entity}
										name="entity"
										onChange={handleChange}
										required
									/>
									<Form.Control.Feedback type="invalid">
										Please provide the name of an entity.
									</Form.Control.Feedback>
								</Form.Group>
							</Col>
							<Col xs={12} md={6} >
								<Form.Group >
									<Form.Label>Campaign Title{<span style={{ color: 'red' }}>*</span>}</Form.Label>
									<Form.Control
										type="text"
										placeholder="Campaign Name"
										value={formData.name}
										name="name"
										onChange={handleChange}
										required
									/>
									<Form.Control.Feedback type="invalid">
										Please provide the name of campaign.
									</Form.Control.Feedback>
								</Form.Group>
							</Col>
						</Row>
						<Row className="mb-3">
							<Col xs={12} md={6} >
								<Form.Group >
									<Form.Label>Batch Size{<span style={{ color: 'red' }}>*</span>}</Form.Label>
									<Form.Control
										type="number"
										placeholder="Recipients per batch"
										value={formData.limit}
										name="limit"
										min={1}
										onChange={handleChange}
										required
									/>
									<Form.Control.Feedback type="invalid">
										Please provide the batch size.
									</Form.Control.Feedback>
								</Form.Group>
							</Col>
							<Col xs={12} md={6} >
								<Form.Group >
									<Form.Label>Start From{<span style={{ color: 'red' }}>*</span>}</Form.Label>
									<Form.Control
										type="number"
										placeholder="Starts From"
										value={formData.offset}
										min={0}
										name="offset"
										onChange={handleChange}
										required
									/>
									<Form.Control.Feedback type="invalid">
										Offset must be provided.
									</Form.Control.Feedback>
								</Form.Group>
							</Col>
						</Row>

						<div>
							<input type="checkbox" id="timerestrictioncheck" onChange={handleTimeRestrictionCheckbox} class="form-check-input" style={{ margin: '5px' }} />
							<label title="" for="timerestrictioncheck" class="form-check-label">
								Schedule Within Time Window
							</label>
						</div>

						<hr style={{ border: '1px solid #7d7d7d', margin: '20px 0' }} />
                        
						 {/* Days of the week: 1 = Sunday, 2 = Monday, ..., 7 = Saturday */}
						<Row className="mb-3" style={{ display: timeRestriction ? 'flex' : 'none' }}>
							<Col xs={12} md={6} >
								<Form.Group >
									<Form.Label>Schedule Days (24 hours){<span style={{ color: 'red' }}>*</span>}</Form.Label>
										<Select
											name='scheduledays'
											value={formData.scheduledays}
											isMulti={true}
											isClearable={false}
											backspaceRemovesValue={true}
											closeMenuOnSelect={true}
											onChange={handleSelectorChange}
											options={days}
											isDisabled={false}
											styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
										/>
								</Form.Group>
							</Col>

							<Col xs={12} md={6} >
								<Form.Group >
									<Form.Label>Time Zone{<span style={{ color: 'red' }}>*</span>}</Form.Label>
									<div style={{ 'border': isListInvalid ? '1px solid #801030' : undefined, 'border-radius': isListInvalid ? '4px' : undefined }}>
										<Select
											name='timezone'
											value={formData.timezone}
											isMulti={false}
											isClearable={false}
											backspaceRemovesValue={true}
											closeMenuOnSelect={true}
											onChange={handleSelectorChange}
											options={timezones}
											isDisabled={false}
											styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
										/>
									</div>
									{isTimezoneInvalid &&
										(<div className='invalid-feedback d-block'>
											Please select timezone.
										</div>)}
								</Form.Group>
							</Col>
						</Row>

						<Row className="mb-3" style={{ display: timeRestriction ? 'flex' : 'none' }}>
							<Col xs={12} md={6}>
								<Form.Group >
									<Form.Label>Start Time{<span style={{ color: 'red' }}>*</span>}</Form.Label>
									<Form.Control
										type="time"
										name="starttime"
										value={formData.starttime}
										onChange={handleChange}
										required={timeRestriction}
										isInvalid={!formData.starttime && validated && timeRestriction}
									/>
									<Form.Control.Feedback type="invalid">
										Start time must be provided.
									</Form.Control.Feedback>
								</Form.Group>
							</Col>
							<Col xs={12} md={6}>
								<Form.Group >
									<Form.Label>End Time{<span style={{ color: 'red' }}>*</span>}</Form.Label>
									<Form.Control
										type="time"
										name="endtime"
										value={formData.endtime}
										onChange={handleChange}
										required={timeRestriction}
										isInvalid={!formData.endtime && validated && timeRestriction}
									/>
									<Form.Control.Feedback type="invalid">
										End time must be provided.
									</Form.Control.Feedback>
								</Form.Group>
							</Col>
						</Row>

						<div className="p-2 d-flex justify-content-between">
							{/* <div>
								<div class="form-check form-switch">
									<input type="checkbox" id="modecheck" onChange={handleModeCheckbox} class="form-check-input" />

									<label title="" for="modecheck" class="form-check-label">
										Fast-Forward Mode
									</label>

									<OverlayTrigger key="tooltip-mode" placement={"right"} overlay={<Tooltip id={`tooltip-mode}`}>In fast-Forward mode, all automatable forms will be submitted. In default Manual Review mode, You can review which Forms you actually want to submit.</Tooltip>}>
										<i class="bi bi-question-circle-fill ps-1"></i>
									</OverlayTrigger>
								</div>
							</div>

							<div>
								<div class="form-check form-switch">
									<input type="checkbox" id="captcacheck" onChange={handleCaptchaCheckbox} class="form-check-input" />

									<label title="" for="modecheck" class="form-check-label">
										Exclude Captcha
									</label>

									<OverlayTrigger key="tooltip-mode" placement={"right"} overlay={<Tooltip id={`tooltip-mode}`}>Check This to Exclude all Forms Where Captcha was detected.</Tooltip>}>
										<i class="bi bi-question-circle-fill ps-1"></i>
									</OverlayTrigger>
								</div>
							</div>

							<div>
								<div class="form-check form-switch">
									<input type="checkbox" id="failedcheck" onChange={handleFailedCheckbox} class="form-check-input" />

									<label title="" for="modecheck" class="form-check-label">
										Exclude Previously Failed
									</label>

									<OverlayTrigger key="tooltip-mode" placement={"right"} overlay={<Tooltip id={`tooltip-mode}`}>Check This to Exclude all Forms That have a history of Failing.</Tooltip>}>
										<i class="bi bi-question-circle-fill ps-1"></i>
									</OverlayTrigger>
								</div>
							</div> */}

							{/* <div>
								<div class="form-check form-switch">
									<input type="checkbox" id="filledcheck" onChange={handleFilledCheckbox} class="form-check-input" />

									<label title="" for="modecheck" class="form-check-label">
										Exclude Previously Filled
									</label>

									<OverlayTrigger key="tooltip-mode" placement={"right"} overlay={<Tooltip id={`tooltip-mode}`}>Check this to exclude all forms that have already been filled.</Tooltip>}>
										<i class="bi bi-question-circle-fill ps-1"></i>
									</OverlayTrigger>
								</div>
							</div> */}
						</div>
						<div className='p-2 d-flex justify-content-end'>
							<Button className="mx-1" title="Cancel" variant="secondary" onClick={() => { props.setShowstartmodal(false); setValidated(false); setFormData({}); setTimeRestriction(false); }}>
								Cancel
							</Button>
                            
							<Button type='submit' disabled = {isloading} className={`mx-1`} title="Start a campaign with selected Template" variant="primary">
								{isloading ? 'Starting...' : 'Start Campaign'}
							</Button> 
							

						</div>
					</Form>
				</Modal.Body>
				{/* <Modal.Footer style={{ justifyContent: "flex-start" }}>
					<p className="mx-1">Note : You cannot run campaign for a paused list. Please wait for the List to get completed or Stop the crawl Job to run a campaign on that list</p>
				</Modal.Footer> */}
			</Modal>
		</>
	)
}

export default StartModal